import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
@Injectable()
export class FilterService {
    private __previews: boolean = true;
    private __ready: boolean = false;
    private __sites: Array<Site> = [];
    private __domains: Array<Domain> = [];
    private __levels: Array<'MAJOR' | 'MINOR'> = [
        "MAJOR",
        "MINOR"
    ];
    private __status: Array<'UNTREATED' | 'TREATED' | 'STILL'> = [
        "STILL",
        "TREATED",
        "UNTREATED"
    ];
    constructor(
        private _storageCtrl: Storage,
    ) {
        this._storageCtrl.get('filter').then(_result => {

            if (_result) {
                let _filter = JSON.parse(_result);
                if (_filter.set) {
                    this.init(_filter.sites, _filter.domains, _filter.levels, _filter.status).then(() => {
                        this.__ready = true;
                    });
                }
                else {
                    this.__previews = false;
                    this.__ready = true;
                }
            } else {
                this.__previews = false;
                this.__ready = true;
            }
        });
    }
    public init(
        _sites: Array<Site>,
        _domains: Array<Domain>,
        _levels: Array<"MAJOR" | "MINOR">,
        _status: Array<'UNTREATED' | 'TREATED' | 'STILL'>,

    ): Promise<boolean> {
        return new Promise((_resolve, _reject) => {
            this.__domains = [..._domains];
            this.__sites = [..._sites];
            this.__levels = [..._levels];
            this.__status = [..._status];
            this.store().then(_result => {
                _resolve(true);
            })
        });

    }
    private store(): Promise<boolean> {
        return new Promise((_resolve, _reject) => {
            this._storageCtrl.set('filter', JSON.stringify({
                set: true,
                sites: this.__sites,
                levels: this.__levels,
                status: this.__status,
                domains: this.__domains,
            })).then(() => {
                _resolve(true);
            })
        });
    }


    public clear(): Promise<boolean> {
        return new Promise((_resolve, _reject) => {

        });
    }
    public subscribe(): Promise<{
        set: boolean,
        sites: Array<Site>,
        domains: Array<Domain>,
        levels: Array<"MAJOR" | "MINOR">,
        status: Array<'UNTREATED' | 'TREATED' | 'STILL'>,
    }> {
        return new Promise((_resolve, _reject) => {
            let inter = setInterval(() => {
                if (this.__ready) {
                    clearInterval(inter);
                    _resolve({
                        set: this.__previews,
                        sites: this.__sites,
                        domains: this.__domains,
                        levels: this.__levels,
                        status: this.__status,
                    });
                }
            }, 500)

        });
    }
}
interface Domain {
    id: number,
    title: string,
    destription: string
}
interface Site {
    id: number,
    title: string,
    destription: string
}


// WEBPACK FOOTER //
// ./src/providers/filter.services.ts